import { getDurationForPartySize } from './get-duration-for-party-size';
import { Service } from '../models';

export function getServicesDurationForPartySize(
  services: Service[],
  selectedServiceIds: string[],
  partySize: number | undefined,
): number {
  return selectedServiceIds.reduce((total, serviceId) => {
    const service = services.find(item => item._id === serviceId);

    return total + (service ? getDurationForPartySize(service, partySize) : 0);
  }, 0);
}
